import { Component } from '@angular/core';

import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';
import {AppService} from "@irb/app.service";
import {IrbClientsEvents} from "@irb/irb-clients/irb-clients.events";

@Component({
  selector: 'port-automated-renderer',
  standalone: true,
  template: `
    @if(showLink) {
        <div style="text-align: center;">
            <a (click)="clickLink()" [innerHTML]="displayValue" class="port-automated-renderer-display"></a>
        </div>
    }
    @if (!showLink) {
        <span></span>
    }
  `
})
export class AutomatedRendererComponent implements ICellRendererAngularComp {

  constructor(public as: AppService) {}

  params: any;
  showLink: boolean = false;
  displayValue: string;
  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.showLink = this.params.value != null;
    if (this.showLink) {
      this.displayValue = this.params.value ? '<img src="./assets/images/success.svg">' : '--';
    }
  }

  refresh(): boolean {
    return true;
  }

  clickLink() {
    this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_PORTFOLIO, {data: this.params.data, automatedRebalanceInit: true});
  }
}
